import React, { useEffect, useState } from "react";
import axios from "axios";
import ReactApexChart from "react-apexcharts";
import { baseurl } from "../Baseurl";
import axiosInstance from "../api/axiosInstance";

const Appointmentgrph = () => {
  const [loading, setLoading] = useState(true);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const getFontSize = () => {
    if (windowWidth > 3000) return 24;
    if (windowWidth > 2500) return 19;
    if (windowWidth >= 2000) return 15;
    if (windowWidth >= 1600) return 13;
    return 11;
  };
  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  useEffect(() => {
    setState((prev) => ({
      ...prev,
      options: {
        ...prev.options,
        xaxis: {
          ...prev.options.xaxis,
          labels: {
            ...prev.options.xaxis.labels,
            style: {
              ...prev.options.xaxis.labels.style,
              fontSize: getFontSize() + "px",
            },
          },
        },
        yaxis: {
          ...prev.options.yaxis,
          labels: {
            ...prev.options.yaxis.labels,
            style: {
              ...prev.options.yaxis.labels.style,
              fontSize: getFontSize() + "px",
            },
          },
        },
      },
    }));
  }, [windowWidth]);
  const [state, setState] = useState({
    series: [
      {
        name: "Appointments",
        data: [],
      },
    ],
    options: {
      chart: {
        height: 250,
        type: "area",
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: "smooth",
        width: 1.5,
      },
      colors: ["#4680ff"],
      fill: {
        type: "gradient",
        gradient: {
          shadeIntensity: 1,
          opacityFrom: 0.5,
          opacityTo: 0,
          colorStops: [
            {
              offset: 0,
              color: "#0d6efd2e",
              opacity: 0.6,
            },
            {
              offset: 100,
              color: "#FFFFFF",
              opacity: 0.1,
            },
          ],
        },
      },
      grid: {
        show: true,
        strokeDashArray: 3,
        borderColor: "#eeeeee",
        xaxis: { lines: { show: false } },
        yaxis: { lines: { show: true } },
      },

      xaxis: {
        type: "category",
        categories: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
        labels: {
          style: {
            colors: "rgb(91,107,121)",
            fontSize: getFontSize(),
          },
        },
      },
      yaxis: {
        min: 0,
        tickAmount: 6,
        labels: {
          style: {
            fontSize: getFontSize() + "px",
            colors: "rgb(91,107,121)",
          },
        },
      },
      tooltip: {
        x: {
          format: "MMM",
        },
      },
    },
  });

  // ✅ Fetch API data and update chart
  const fetchChartData = async () => {
    try {
      const response = await axiosInstance.get(
        `dashboard/appointments_graph`
      );
      if (response.status === 200 && response.data.success) {
        const apiData = response.data.data || [];

        // Month mapping
        const months = [
          "January",
          "February",
          "March",
          "April",
          "May",
          "June",
          "July",
          "August",
          "September",
          "October",
          "November",
          "December",
        ];

        // Convert API data into a map
        const apiMap = {};
        apiData.forEach((item) => {
          apiMap[item.month] = item.total;
        });

        // Create array with all months (fill missing with 0)
        const totals = months.map((month) => apiMap[month] || 0);

        // ✅ Update chart data
        setState((prev) => ({
          ...prev,
          series: [{ name: "Appointments", data: totals }],
        }));
      } else {
        console.warn("Failed to fetch chart data");
      }
    } catch (error) {
      console.error("API Error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchChartData();
  }, []);

  if (loading) return <p>Loading chart...</p>;
  const getChartHeight = () => {
    if (windowWidth > 3000) return 500;
    if (windowWidth > 2500) return 380;
    if (windowWidth >= 2000) return 320;
    if (windowWidth >= 1600) return 270;
    return 250;
  };
  return (
    <div>
      <div id="chart">
        <ReactApexChart
          options={state.options}
          series={state.series}
          height={getChartHeight()}
          type="area"
          // height={250}
          key={windowWidth}
        />
      </div>
    </div>
  );
};

export default Appointmentgrph;
